import { HorizontalDivider, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';

import { StepIndex } from '../StepIndex';
import { ValidationErrorsNotification } from '../ValidationErrors';

import * as S from './style';

export function ReviewSection({
  id,
  stepIndex = 1,
  isCompleted = false,
  title,
  subTitle,
  titleHintText,
  warnings,
  headerChildren,
  children
}) {
  return (
    <S.ReviewSectionWrapper isCompleted={isCompleted} id={id}>
      <S.HeaderWrapper>
        <S.Col>
          <StepIndex
            stepIndex={stepIndex}
            isCompleted={isCompleted}
            hasWarning={!!warnings?.length}
          />
          <S.TitleWrapper>
            <S.TitleCol>
              <Typography variant="subtitle1SemiBold" color="fg">
                {title}
              </Typography>
              {titleHintText}
            </S.TitleCol>
            <Typography variant="body1" color="fg" emphasis="weaker">
              {subTitle}
            </Typography>
          </S.TitleWrapper>
        </S.Col>
        <S.Col>{headerChildren}</S.Col>
      </S.HeaderWrapper>

      {!!warnings?.length && (
        <ValidationErrorsNotification style={{ marginBottom: 24 }} errors={{ warning: warnings }} />
      )}
      {children}
      <HorizontalDivider $margin="40px 0" />
    </S.ReviewSectionWrapper>
  );
}

ReviewSection.propTypes = {
  stepIndex: PropTypes.number,
  isCompleted: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  headerChildren: PropTypes.node,
  children: PropTypes.node
};
